/* eslint-disable */
import React, { FC } from 'react';
import { Col, Divider, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Alert, AmountField, SpaceBetweenField } from '~/components';
import theme from '~/constants/theme';
import { useDirection } from '~/hooks/i18nHooks';
import { DirectionProp } from '~/types/Direction';
import { PricingDto } from '~/types/PricingDto';
import { PricingRequestStatus } from '~/types/Services';
import CustomPricingStatusAlert from './views/ServicesView/CustomPricingStatusAlert';
import { useIsMobile } from '~/hooks/useScreenSizes';
import { cloneDeep, set } from 'lodash';

export interface TotalPriceProps {
  pricing?: PricingDto['pricing'];
  isError?: boolean;
  isLoading?: boolean;
  isStale?: boolean;
  requiresRecalculate?: boolean;
  pricingRequestStatus: PricingRequestStatus | undefined;
}

const TotalPrice: FC<TotalPriceProps> = (props) => {
  const {
    pricing = {},
    isError,
    isLoading,
    isStale,
    requiresRecalculate,
    pricingRequestStatus,
  } = props;
  const clonedPricing = cloneDeep(pricing);
  const { t } = useTranslation('ksaApplication');
  const dir = useDirection();
  const isMobile = useIsMobile();
  return (
    <Container
      className="TotalPrice"
      disabled1={!!(isLoading || isStale || requiresRecalculate)}
      disabled2={!!isError}
      dir={dir}
      isMobile={isMobile}
      requiresRecalculate={!!requiresRecalculate}
    >
      <div className="TotalPrice-Filters">
        {Object.entries(clonedPricing ?? {})
          .filter(([key]) => {
            if (!isMobile) {
              return !(key === 'Total' || key === 'VAT 5%');
            }
            return !(key === 'Total');
          })
          .map(([key, value]: any, index) => {
            const qty = key === 'N-Genius POS' ? value.amount.value / 1999 : 1;
            return (
              <>
                <Row key={key} className="TotalPrice-Rest">
                  <Col className="text-key" span={16}>
                    <Typography.Paragraph className={isMobile ? 'keyText' : 'keyTextDesktop'}>
                      {t(key)}
                    </Typography.Paragraph>
                    {/* {!isMobile && <Typography.Paragraph className="qty-text">{`Qty: ${qty}`} </Typography.Paragraph>} */}
                  </Col>
                  <Col
                    span={8}
                    style={{
                      paddingTop: isMobile ? 5 : '8px',
                      textAlign: dir === 'rtl' ? 'left' : 'right',
                    }}
                  >
                    <AmountField
                      id={`amountFieldAdditional_${index}`}
                      amount={value.amount}
                      alwaysShowDecimalPart
                    />
                  </Col>
                </Row>
              </>
            );
          })}
      </div>
    </Container>
  );
};

interface ContainerProps extends DirectionProp {
  disabled1: boolean;
  disabled2: boolean;
  requiresRecalculate: boolean;
  isMobile?: boolean;
}

const Container = styled.div<ContainerProps>`
  position: relative;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  padding-left: 12px;
  margin-right: 10px;

  .TotalPrice-Filters {
    width: auto;
    opacity: ${({ disabled1, disabled2 }) => (disabled1 || disabled2 ? 0.3 : 1)};
    filter: ${({ disabled1 }) => (disabled1 ? 'blur(3px)' : undefined)};
    filter: ${({ disabled2 }) => (disabled2 ? 'blur(7px)' : undefined)};
  }
  .keyText {
    color: #000;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.14px;
  }

  .keyTextDesktop {
    color: #000;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px;
    margin-bottom: 0;
  }

  .TotalPrice-Total {
    font-size: 16px;
    margin-bottom: 8px;
  }

  .TotalPrice-Tax {
    margin-bottom: 24px;
  }

  .qty-text {
    color: #7c7878;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 166.667% */
    letter-spacing: 0.12px;
  }

  .TotalPrice-Rest {
    // width: ${({ isMobile }) => (isMobile ? 'undefined' : '310px')};
    font-size: 12px;
    line-height: 14px;
    margin-bottom: 3px;
    width: 100%;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .text-key {
    display: flex;
    flex-direction: column;
    color: #000;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px; /* 200% */
  }

  //margin-bottom: 20px;
`;

export default TotalPrice;
